/** Batch audio goes directly to ElevenLabs with a single-use token, never an API key. */
export async function transcribeAudio(file: File, token: string, signal: AbortSignal): Promise<string> {
  const body = new FormData()
  body.append('file', file)
  body.append('model_id', 'scribe_v2')
  body.append('timestamps_granularity', 'none')
  body.append('tag_audio_events', 'false')
  const response = await fetch(`https://api.elevenlabs.io/v1/speech-to-text?token=${encodeURIComponent(token)}`, {
    method: 'POST', body, signal,
  })
  if (!response.ok) throw new Error('Could not transcribe this recording. Retry or choose another audio file.')
  const result: { text?: unknown } = await response.json()
  if (typeof result.text !== 'string' || !result.text.trim()) throw new Error('No speech was found in this recording.')
  return result.text.trim()
}
